export const ADD_CONTRACT_NOTES_MODAL_NAME = 'ADD_CONTRACT_NOTES_MODAL_NAME';
